import { render, staticRenderFns } from "./IdCardConfirm.vue?vue&type=template&id=5bc07c7e&scoped=true&"
import script from "./IdCardConfirm.vue?vue&type=script&lang=js&"
export * from "./IdCardConfirm.vue?vue&type=script&lang=js&"
import style0 from "./IdCardConfirm.vue?vue&type=style&index=0&id=5bc07c7e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc07c7e",
  null
  
)

export default component.exports